import React from 'react';
import PropTypes from 'prop-types';
import Text from '../basic/Text';

export default function DateFormat({
 value, children, ...rest
}) {
  return (
    <Text {...rest}>
      {new Intl.DateTimeFormat({ ...rest }).format(new Date(children ? children : value))}
    </Text>
  );
}

DateFormat.propTypes = {
  value: PropTypes.string,

};
DateFormat.defaultProps = {
  value: null,
};
